import { inject, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariablesService } from '@services/variables/variables.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tip-select-nudge',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, FormsModule],
  templateUrl: './tip-select-nudge.component.html',
  styleUrls: ['./tip-select-nudge.component.scss']
})
export class TipSelectNudgeComponent {

  public vars = inject(VariablesService);

  @Input() currency;
  @Input() amount;
  @Input() baseAmount;
  @Input() selectedTipPerc;
  @Output() setLastTipAmt = new EventEmitter();
  @Output() setTipAmount = new EventEmitter();
  @Output() setTipPercent = new EventEmitter();

  defaultTipPerc = 5;
  tipEnable = true;
  tipAmt = 0;

  ngOnInit() {
    if (!this.vars.numberOnlyRegex.test(this.selectedTipPerc)) {
      this.selectedTipPerc = this.defaultTipPerc;
    }
    this.selectTip(this.selectedTipPerc);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes && changes.baseAmount) || changes.amount || changes.currency) {
      this.selectTip(this.tipEnable ? this.selectedTipPerc : 0);
      if (changes?.baseAmount?.currentValue) {
        this.baseAmount = changes.baseAmount.currentValue;
      }
    }
  }

  onCheckBoxChange(e) {
    this.selectTip(e.checked ? this.selectedTipPerc : 0);
  }

  selectTip(tipPerc) {
    this.vars.selectTipPercentage = tipPerc;
    if (tipPerc === 0) {
      this.setTipAmount.emit(0);
      this.setTipPercent.emit(tipPerc);
      return false;
    }
    this.setTipAmount.emit(this.calculateTip(tipPerc));
    this.setTipPercent.emit(tipPerc);
  }

  calculateTip(tip) {
    let amt = Math.round((this.baseAmount * tip) / 100)
    if (amt === 0 && this.tipEnable) {
      amt = 1;
    }
    return amt;
  }

}
